export class TextValue {
  Text:string = "";
  Value:string = "";
  IntValue:number = 0;

  constructor(init:Partial<TextValue>) {
    if(init) {
      this.Text = init.Text??"";
      this.Value = init.Value??"";
      this.IntValue = init.IntValue??0;
    }
  }
}